// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"401":"a79df291dddf880a","855":"3b5edc61d41a9974"}[chunkId] + ".js";
};